module.exports = __webpack_public_path__ + "static/img/employee-03-big.12a98f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-03-big.png
// module id = UWTr
// module chunks = 2